import { I } from '@angular/cdk/keycodes';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { FusionChartsService } from 'src/app/_services/fusion-charts.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import * as _ from "underscore";
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddCompanyModalComponent } from '../add-company-modal/add-company-modal.component';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { HashService } from 'src/app/_services/hash.service';
import { SessionStorageService } from 'src/app/_services/session-storage.service';
import * as __ from 'lodash';
import { GlobalService } from 'src/app/_services/global.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
declare const clevertap;

interface IHireDepartureTalent {
  company: string;
  date: string;
  hireTalent: number;
  departureTalent: number;
  totalTalent?: number;
  order: number;
  label: string;
}
@Component({
    selector: 'app-company-comparison-overview',
    templateUrl: './company-comparison-overview.component.html',
    styleUrls: ['./company-comparison-overview.component.scss'],
    standalone: false
})
export class CompanyComparisonOverviewComponent implements OnInit {

  companyDetailsOne: any;
  viewMore = false;
  companyOneTags: string[];
  viewMore2 = false
  companyDetailsTwo: any;
  companyTwoTags: string[];
  alternateCompanyNamesOne: string[];
  companyIdOne: string = this.localStorageService.getItem('companyOneId');//this.companyInsightsService.companycompareone[0]?.id
  genderChart: any = [];
  topLocationsCompanyOne: any[] = [];
  locationCompanyOneLoader: boolean = false;
  totalResultCountCompanyOne: number;
  functionsCompanyOne: any[];
  functionCompanyOneLoader: boolean = false;
  companiesGainingOne: any[];
  companyGainingOneLoader: Boolean = false;
  primaryCompanyInformation: any = {};
  companiesLosingOne: any[] = [];
  companyLosingLoaderOne: boolean = false;
  titlesCompanyOne: any[] = [];
  titleLoaderOne: boolean = false;
  ethnicityLoaderOne: Boolean = false;
  ethnicityChartCompanyOne: any = [];
  keyPeopleDataCompanyOne: any[] = [];
  keyPeopleLoaderCompanyOne: Boolean = false;
  alternateCompanyNamesTwo: string[];
  companyIdTwo: string = this.localStorageService.getItem('companyTwoId')//this.companyInsightsService.companycomparetwo[0]?.id
  genderChartCompanyTwo: any = [];
  topLocationsCompanyTwo: any[];
  locationCompanyTwoLoader: Boolean = false;
  totalResultCountCompanyTwo: number;
  functionsCompanyTwo: any[] = [];
  functionCompanyTwoLoader: Boolean = false;
  companiesGainingTwo: any[];
  companyGainingTwoLoader: Boolean = false;
  companyLosingLoaderTwo: boolean = false;
  companiesLosingTwo: any[];
  titleLoaderTwo: Boolean = false;
  titlesCompanyTwo: any[] = [];
  ethnicityLoaderTwo: Boolean = false;
  ethnicityChartCompanyTwo: any = [];
  keyPeopleLoaderCompanyTwo: Boolean = false;
  keyPeopleDataCompanyTwo: any[] = [];
  seniorityLoaderCompanyOne: Boolean = false;
  seniorityDataCompanyOne: any = [];
  seniorityDataCompanyTwo: any = [];
  seniorityLoaderCompanyTwo: Boolean = false;
  /**
 * Get the company name
 */
  get company(): string {
    return this.companyDetailsOne ? this.companyDetailsOne.name : '';
  }

  hireDepartureTalent: IHireDepartureTalent[] = [];
  dataAvailable = {
    hiresAndDepartures: false,
    winningLosingTalent: false
  }
  hireDepartureTalentDataSource: any = {};
  hireDepartureTalentTwo: IHireDepartureTalent[] = [];
  hireDepartureTalentDataSourceTwo: any = {};
  /**
 * Get the company name
 */
  get companyTwo(): string {
    return this.companyDetailsTwo ? this.companyDetailsTwo.name : '';
  }
  showCountJobtitle: number = 0;
  showCountCompanyLosing: number = 0;
  showCountCompanyWinning: number = 0;
  showCountFunctions: number = 0;
  showCountLocations: number = 0;
  showCountProfiles: number = 0;

  maxLength = 190;
  viewMoreCompanyTwo: boolean = false
  viewMoreTagsCompanyOne = false;
  tagDisplayLimit = 6;
  viewMoreTagsCompanyTwo = false;
  companyoneWinningTalenCount: number = 0;
  companytwoWinningTalenCount: number = 0;
  companyoneLoosingTalenCount: number = 0;
  companytwoLoosingTalenCount: number = 0;
  subscriptions: Subscription[] = [];
  hiresAndAttritionObj: any = {};
  abs(params: number) {
    return Math.abs(params);
  }
  hiresAndAttritionObjCompanyTwo: any = {};
  companyinsightsFilter: any = {};
  talentMovementCompanyOneLoaader: boolean = false;
  classCount = 5;
  genderCompanyOneLoader: Boolean = false;
  genderChartCompanyTwoLoader: Boolean = false;
  companyNameOne: string;
  companyNameTwo: string;
  talentMovementCompanyTwoLoaader: boolean = false;
  companyOneLoader: boolean = false;
  companyTwoLoader: boolean = false;
  companyOneAISummary: any = {};
  companyTwoAISummary: any = {};
  companyNames: any[] = [];
  shrinkdivonscroll: boolean = false
  medianTanuresCompanyOneCount: number;
  medianTenureCompanyTwoCount: number;
  keyProfessionalOneLoader: boolean = false;
  keyProfessionalTwoLoader: boolean = false;
  companyOneExport: any = {};
  companyTwoExport: any = {};
  @Input() export;
  errorMessage: string;
  successMessage: string;
  aiSummary: any;
  winningCompanyTrends: any[] = [];
  loosingCompanyTrends: any[] = [];
  talentmovementGraphData: any[] = [];
  winningTrendsCompanyTwo: any[] = [];
  loosingTrendsCompanyTwo: any[] = [];
  talentmovementGraphDataCompanyTwo: any[] = [];
  isCollapsed = false;
  constructor(private companyInsightsService: CompanyInsightsService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private fusionChartService: FusionChartsService,
    private personSearchService: PersonSearchService, private filterDataHandlerService: FilterDataHandlerService, private localStorageService: LocalStorageService,
    private modalService: NgbModal, private router: Router, private hashService: HashService, private sessionStorageService: SessionStorageService) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
     })
    }

  ngOnInit() {
    this.fetchPageData();
    this.filterDataHandlerService.reset();

    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

    const exportDataEvent = this.companyInsightsService.fetchCompanyExportData.subscribe(res => this.fetchExportData(res));
    this.subscriptions.push(exportDataEvent);
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.scrollY > 2) {
      this.shrinkdivonscroll = true;
    } else {
      this.shrinkdivonscroll = false;
    }
  }
  //  onWindowScroll() {
  //   const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  //   this.isCollapsed = scrollPosition > 100;
  // }
  fetchPageData() {
    this.companyOneAISummary = {};
    this.companyTwoAISummary = {};
    if (this.companyIdOne && !this.companyIdTwo)
      this.getDetailsOfCompanyOne();
    else if (!this.companyIdOne && this.companyIdTwo)
      this.getDetailsOfCompanyTwo();
    else
      this.loadCompanyDetailsInSequence();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  async getDetailsOfCompanyOne(): Promise<void> {
    this.companyDetailsOne = {};
    this.companyOneLoader = true;
    this.topLocationsCompanyOne = [];
    this.genderChart = [];
    this.locationCompanyOneLoader = true;
    this.functionCompanyOneLoader = true;
    this.functionsCompanyOne = [];
    this.companyGainingOneLoader = true;
    this.companiesGainingOne = [];
    this.companiesLosingOne = [];
    this.companyLosingLoaderOne = true;
    this.seniorityDataCompanyOne = {};
    this.seniorityLoaderCompanyOne = true;
        this.titleLoaderOne = true;
    this.titlesCompanyOne= [];
    this.ethnicityChartCompanyOne = [];
    this.ethnicityLoaderOne = true;
    this.keyPeopleDataCompanyOne = [];
    this.keyPeopleLoaderCompanyOne = true;
    this.keyProfessionalOneLoader = true;
    const res: any = await this.companyInsightsService.getCompanyDetailsById(this.companyIdOne).toPromise();
    this.companyOneLoader = false;
    this.companyDetailsOne = res.data;
    this.companyNameOne = this.companyDetailsOne.name;

    if (this.companyDetailsOne?.tags) {
      this.companyOneTags = this.companyDetailsOne.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }
    this.companyDetailsOne.latest_funding_stage = this.companyDetailsOne?.latest_funding_stage?.replace(/_/g, ' ')

    this.alternateCompanyNamesOne = this.companyDetailsOne?.alternative_names?.length > 0
      ? this.companyDetailsOne.alternative_names.concat([this.companyDetailsOne.name])
      : [this.companyDetailsOne.name];

    await Promise.all([
      this.getMedianTanureCount('companyone'),
      this.getcompanywinninglosingtalent('companyone'),
      this.getGrowthRateAttrtionRateData('companyone'),
      this.getCompanyOneGenderChart('companyone'),
      this.getCompanyOneLocations('companyone'),
      this.getCompanyOneFunctions('companyone'),
      this.getcompanywinningTalentFrom('companyone'),
      this.getcompanylosingtalentto('companyone'),
      this.getCompanyOneTitles('companyone'),
      // this.getCompanyOneEthnicity('companyone'),
      this.getKeyPeopleCompaanyOneData('companyone'),
      this.getCompanySeniorityData('companyone'),
    ]);
  }

  get displaySummaryCompanyOne(): string {
    const summary = this.companyDetailsOne?.summary || '';
    if (this.viewMore || summary.length <= this.maxLength) {
      return summary.charAt(0).toUpperCase() + summary.slice(1);
    }
    return summary.charAt(0).toUpperCase() + summary.slice(1, this.maxLength);
  }

  get visibleTagsCompanyOne() {
    return this.viewMoreTagsCompanyOne
      ? this.companyOneTags
      : this.companyOneTags?.slice(0, this.tagDisplayLimit);
  }

  get hiddenTagCountCompanyOne(): number {
    return this.companyOneTags?.length - this.tagDisplayLimit;
  }

  async getDetailsOfCompanyTwo(): Promise<void> {
    this.companyDetailsTwo = {};
    this.companyTwoLoader = true;
    this.locationCompanyTwoLoader = true;
    this.talentMovementCompanyTwoLoaader = true;
    this.genderChartCompanyTwoLoader = true;
    this.functionCompanyTwoLoader = true;
    this.companyGainingTwoLoader = true;
    this.companyLosingLoaderTwo = true;
    this.seniorityLoaderCompanyTwo = true;
    this.titleLoaderTwo = true;
    this.ethnicityLoaderTwo = true;
    this.keyPeopleLoaderCompanyTwo = true;
    this.genderChartCompanyTwo = null;
    this.topLocationsCompanyTwo = [];
    this.functionsCompanyTwo = [];
    this.companiesGainingTwo = [];
    this.companiesLosingTwo = [];
    this.seniorityDataCompanyTwo = {};
    this.titlesCompanyTwo = [];
    this.ethnicityChartCompanyTwo = [];
    this.keyPeopleDataCompanyTwo = [];
    this.keyProfessionalTwoLoader = true;
    const res: any = await this.companyInsightsService.getCompanyDetailsById(this.companyIdTwo).toPromise();
    this.companyDetailsTwo = res.data;
    this.companyNameTwo = this.companyDetailsTwo.name;

    this.companyTwoLoader = false;
    if (this.companyDetailsTwo && this.companyDetailsTwo.tags) {
      this.companyTwoTags = this.companyDetailsTwo.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }
    this.companyDetailsTwo.latest_funding_stage = this.companyDetailsTwo?.latest_funding_stage?.replace(/_/g, ' ')

    this.alternateCompanyNamesTwo = this.companyDetailsTwo?.alternative_names?.length > 0 ? this.companyDetailsTwo.alternative_names.concat([this.companyDetailsTwo.name]) : [this.companyDetailsTwo.name];
    await Promise.all([

      this.getcompanywinninglosingtalent('companytwo'),
      this.getGrowthRateAttrtionRateData('companytwo'),
      this.getCompanyOneGenderChart('companytwo'),
      this.getCompanyOneLocations('companytwo'),
      this.getCompanyOneFunctions('companytwo'),
      this.getcompanywinningTalentFrom('companytwo'),
      this.getcompanylosingtalentto('companytwo'),
      this.getCompanyOneTitles('companytwo'),
      // this.getCompanyOneEthnicity('companytwo'),
      this.getKeyPeopleCompaanyOneData('companytwo'),
      this.getCompanySeniorityData('companytwo'),
      this.getMedianTanureCount('companytwo')
    ]);

  }


  get displaySummaryCompanyTwo(): string {
    const summary = this.companyDetailsTwo?.summary || '';
    if (this.viewMoreCompanyTwo || summary.length <= this.maxLength) {
      return summary.charAt(0).toUpperCase() + summary.slice(1);
    }
    return summary.charAt(0).toUpperCase() + summary.slice(1, this.maxLength);
  }

  get visibleTagsCompanyTwo() {
    return this.viewMoreTagsCompanyTwo
      ? this.companyTwoTags
      : this.companyTwoTags?.slice(0, this.tagDisplayLimit);
  }

  get hiddenTagCountCompanyTwo(): number {
    return this.companyTwoTags?.length - this.tagDisplayLimit;
  }
  async loadCompanyDetailsInSequence(): Promise<void> {
    await this.getDetailsOfCompanyOne();
    await this.getDetailsOfCompanyTwo(); // Runs only after the above completes

  }


  /**
   * Gender Diversity for company comparison
   */
  getCompanyOneGenderChart(type) {
    let aggReq: AggregationRequest = new TIAggRequest();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.aggregatetype = "gender";
    if (type == 'companyone') {
      this.genderChart = null
      aggReq.companies = this.alternateCompanyNamesOne;
      aggReq.companyids = [this.companyIdOne];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.genderCompanyOneLoader = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        const data = response.data.aggregations.gender;
        this.genderChart = this.fusionChartService.genderDiversityChart(data);
        this.genderCompanyOneLoader = false;
        this.companyOneAISummary = {
          ...this.companyOneAISummary,
          gender: data
        }
        this.generateai();

      });
    } else if (type == 'companytwo') {
      this.genderChartCompanyTwo = null
      aggReq.companies = this.alternateCompanyNamesTwo;
      aggReq.companyids = [this.companyIdTwo];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.genderChartCompanyTwoLoader = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        const data = response.data.aggregations.gender;
        this.genderChartCompanyTwo = this.fusionChartService.genderDiversityChart(data);
        this.genderChartCompanyTwoLoader = false;
        this.companyTwoAISummary = {
          ...this.companyTwoAISummary,
          gender: data
        }
        this.generateai();
      });
    }

  }

  /**
   * Locations for Company Comparison
   */
  getCompanyOneLocations(type) {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "location";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    if (type == 'companyone') {
      this.topLocationsCompanyOne = [];
      aggReq.companies = this.alternateCompanyNamesOne;
      aggReq.companyids = [this.companyIdOne];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.locationCompanyOneLoader = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.topLocationsCompanyOne = response.data.aggregations.location;
        this.showCountLocations = 5;
        this.totalResultCountCompanyOne = response.data.totalresultscount;
        this.locationCompanyOneLoader = false;
        const locationsCompanyOne = this.topLocationsCompanyOne.map(loc => {
          return { ...loc, totalpercentage: this.getCompanyComparePercent(loc.doc_count, 'company') }
            ;
        })
        this.companyOneAISummary = {
          ...this.companyOneAISummary,
          locations: locationsCompanyOne
        };
        this.companyOneExport = {
          ...this.companyOneExport,
          locations: locationsCompanyOne
        }

        this.generateai();

      });
    } else if (type == 'companytwo') {
      this.topLocationsCompanyTwo = [];
      aggReq.companies = this.alternateCompanyNamesTwo;
      aggReq.companyids = [this.companyIdTwo];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.locationCompanyTwoLoader = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.topLocationsCompanyTwo = response.data.aggregations.location;
        this.showCountLocations = 5;
        this.totalResultCountCompanyTwo = response.data.totalresultscount;
        this.locationCompanyTwoLoader = false;
        const locationsCompany = this.topLocationsCompanyTwo.map(loc => {
          return { ...loc, totalpercentage: this.getCompanyCompareTwoPercent(loc.doc_count, 'company') }
            ;
        })
        this.companyTwoAISummary = {
          ...this.companyTwoAISummary,
          locations: locationsCompany
        };
        this.companyTwoExport = {
          ...this.companyTwoExport,
          companylocations: locationsCompany
        }

        this.generateai();

      });
    }

  }

  getCompanyComparePercent(count, type?) {
    if (type == 'company')
      return ((count / this.totalResultCountCompanyOne) * 100).toFixed();
    else if (type == 'winning')
      return ((count / this.companyoneWinningTalenCount) * 100).toFixed();
    else if (type == 'loosing')
      return ((count / this.companyoneLoosingTalenCount) * 100).toFixed();

  }

  getCompanyCompareTwoPercent(count, type) {
    if (type == 'company')
      return ((count / this.totalResultCountCompanyTwo) * 100).toFixed();
    else if (type == 'winning') {
      return ((count / this.companytwoWinningTalenCount) * 100).toFixed();
    }
    else if (type == 'loosing') {
      return ((count / this.companytwoLoosingTalenCount) * 100).toFixed();

    }
  }

  getCompanyOneFunctions(type) {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "current_function";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    if (type == 'companyone') {
      this.functionsCompanyOne = [];
      aggReq.companies = this.alternateCompanyNamesOne;
      aggReq.companyids = [this.companyIdOne];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.functionCompanyOneLoader = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.functionsCompanyOne = response.data.aggregations.current_function;
        this.showCountFunctions = 5;
        this.functionCompanyOneLoader = false;
        this.totalResultCountCompanyOne = response.data.totalresultscount;

        const functionsCompany = this.functionsCompanyOne.map(loc => {
          return { ...loc, totalpercentage: this.getCompanyComparePercent(loc.doc_count, 'company') }
            ;
        })
        this.companyOneAISummary = {
          ...this.companyOneAISummary,
          functions: functionsCompany
        }

        this.companyOneExport = {
          ...this.companyOneExport,
          functions: functionsCompany
        }
        this.generateai();

      })
    } else if (type == 'companytwo') {
      aggReq.companies = this.alternateCompanyNamesTwo;
      aggReq.companyids = [this.companyIdTwo];
      this.functionsCompanyTwo = [];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.functionCompanyTwoLoader = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.functionsCompanyTwo = response.data.aggregations.current_function;
        this.showCountFunctions = 5;
        this.functionCompanyTwoLoader = false;
        this.totalResultCountCompanyTwo = response.data.totalresultscount;

        const functionsCompany = this.functionsCompanyTwo.map(loc => {
          return { ...loc, totalpercentage: this.getCompanyCompareTwoPercent(loc.doc_count, 'company') }
            ;
        })
        this.companyTwoAISummary = {
          ...this.companyTwoAISummary,
          functions: functionsCompany
        }

        this.companyTwoExport = {
          ...this.companyTwoExport,
          functions: functionsCompany
        }
        this.generateai();

      })
    }

  }

  getcompanywinningTalentFrom(type) {
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    requestObject.resultsize = 10;
    requestObject.startindex = 0;
    if (type == 'companyone') {
      requestObject.companies = this.alternateCompanyNamesOne;
      requestObject.functiontype = 'Current';
      requestObject.companyids = [this.companyIdOne];
      this.companyGainingOneLoader = true;
      this.companiesGainingOne = [];
      this.companyInsightsService.getcompanywinningTalentFrom(requestObject).subscribe((response) => {
        if (response.status == "success") {
          this.companiesGainingOne = response.aggregations.winningtalentfromcompany;
          this.companyoneWinningTalenCount = response.totalresultscount;
          this.showCountCompanyWinning = 5;
          this.companyGainingOneLoader = false;
          this.getCompaniesGainingLogo('companyone');
          const companyGaining = this.companiesGainingOne.map(winning => {
            return { ...winning, totalpercentage: this.getCompanyComparePercent(winning.doc_count, 'winning') }
              ;
          })
          this.companyOneAISummary = {
            ...this.companyOneAISummary,
            winningtalentfromcompany: companyGaining
          }

          this.companyOneExport = {
            ...this.companyOneExport,
            winningtalentfromcompany: companyGaining
          }
          this.generateai();

        }
      });
    } else if (type == 'companytwo') {
      this.companiesGainingTwo = [];
      requestObject.companies = this.alternateCompanyNamesTwo;
      requestObject.functiontype = 'Current';
      requestObject.companyids = [this.companyIdTwo];
      this.companyGainingTwoLoader = true;
      this.companyInsightsService.getcompanywinningTalentFrom(requestObject).subscribe((response) => {
        if (response.status == "success") {
          this.companiesGainingTwo = response.aggregations.winningtalentfromcompany;
          this.companytwoWinningTalenCount = response.totalresultscount;

          this.showCountCompanyWinning = 5;
          this.companyGainingTwoLoader = false;
          this.getCompaniesGainingLogo('companytwo');

          const companyGaining = this.companiesGainingTwo.map(winning => {
            return { ...winning, totalpercentage: this.getCompanyCompareTwoPercent(winning.doc_count, 'winning') }
              ;
          })
          this.companyTwoAISummary = {
            ...this.companyTwoAISummary,
            winningtalentfromcompany: companyGaining
          }

          this.companyTwoExport = {
            ...this.companyTwoExport,
            winningtalentfromcompany: companyGaining
          }
          this.generateai();

        }
      });
    }

  }

  getCompaniesGainingLogo(type) {
    if (type == 'companyone') {
      if (this.companiesGainingOne) {
        let companyLogoPayload = this.companiesGainingOne.map(item => {
          if (item.id || item.key) {
            return {
              ...(item?.id && { id: item.id }),
              ...(item?.key && { name: item.key })
            }
          }
        }).filter(Boolean);

        companyLogoPayload?.length &&
          this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
            if (res && res.status == "success") {
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = this.companiesGainingOne.find((item) => item.key === obj.key);
                if (matchingObj) {
                  let companyLogo = obj.companylogo
                  matchingObj.companylogo = companyLogo;
                  matchingObj.website = obj.website;
                }
              });
            }
            const companyGaining = this.companiesGainingOne.map(winning => {
              return { ...winning, companylogo: winning.companylogo, totalpercentage: this.getCompanyComparePercent(winning.doc_count, 'winning') }
                ;
            })
            this.companyOneAISummary = {
              ...this.companyOneAISummary,
              winningtalentfromcompany: companyGaining
            }

            this.companyOneExport = {
              ...this.companyOneExport,
              winningtalentfromcompany: companyGaining
            }
          });

      }
    } else if (type == 'companytwo') {
      if (this.companiesGainingTwo) {
        let companyLogoPayload = this.companiesGainingTwo.map(item => {
          if (item.id || item.key) {
            return {
              ...(item?.id && { id: item.id }),
              ...(item?.key && { name: item.key })
            }
          }
        }).filter(Boolean);

        companyLogoPayload?.length &&
          this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
            if (res && res.status == "success") {
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = this.companiesGainingTwo.find((item) => item.key === obj.key);
                if (matchingObj) {
                  let companyLogo = obj.companylogo
                  matchingObj.companylogo = companyLogo;
                  matchingObj.website = obj.website;

                }
                const companyGaining = this.companiesGainingTwo.map(winning => {
                  return { ...winning, companylogo: winning.companylogo, totalpercentage: this.getCompanyCompareTwoPercent(winning.doc_count, 'winning') }
                    ;
                })
                this.companyTwoAISummary = {
                  ...this.companyTwoAISummary,
                  winningtalentfromcompany: companyGaining
                }


                this.companyTwoExport = {
                  ...this.companyTwoExport,
                  winningtalentfromcompany: companyGaining
                }
              });
            }
          });

      }
    }

  }

  getCompanyInfo(companyname) {
    let companyData = [];
    if (companyname) {
      companyData = [{
        name: companyname
      }];
    }
    companyData?.length &&
      this.personSearchService.getCompanyLogoV2(companyData).subscribe((res: any) => {
        if (res.status == 'success' && res.data) {
          let companyDetails = res.data[0]
          this.primaryCompanyInformation['website'] = companyDetails.website ? companyDetails.website : null;
          this.primaryCompanyInformation['name'] = companyDetails.name ? companyDetails.name : null;
          this.primaryCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : null;
          this.primaryCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : null;
          this.primaryCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : null;
          this.primaryCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : null;
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['id'] = companyDetails.id
          this.primaryCompanyInformation['companylogo'] = companyDetails.companylogo
          this.primaryCompanyInformation['key_id'] = companyDetails.id
          this.primaryCompanyInformation['twitter_url'] = companyDetails.twitter_url ? companyDetails.twitter_url : null;
          this.primaryCompanyInformation['github_url'] = companyDetails.github_url ? companyDetails.github_url : null;
          this.primaryCompanyInformation['facebook_url'] = companyDetails.facebook_url ? companyDetails.facebook_url : null;
        }
      });
  }

  getcompanylosingtalentto(type) {
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    requestObject.resultsize = 10;
    requestObject.startindex = 0;
    requestObject.functiontype = 'Current';
    if (type == 'companyone') {
      this.companiesLosingOne = [];
      requestObject.companies = this.alternateCompanyNamesOne;
      requestObject.companyids = [this.companyIdOne];
      this.companyLosingLoaderOne = true;
      this.companyInsightsService.getcompanylosingtalentto(requestObject).subscribe((response) => {
        if (response.status == "success") {
          this.companiesLosingOne = response.aggregations.losingtalenttocompany;
          this.companyoneLoosingTalenCount = response.totalresultscount;

          this.showCountCompanyLosing = 5;
          this.companyLosingLoaderOne = false;
          this.getCompaniesLosingLogo('companyone');
          const companyLosing = this.companiesLosingOne.map(loosing => {
            return { ...loosing, companylogo: loosing.companylogo, totalpercentage: this.getCompanyComparePercent(loosing.doc_count, 'loosing') }
              ;
          })
          this.companyOneAISummary = {
            ...this.companyOneAISummary,
            loosingtalenttocompany: companyLosing
          }

          this.companyOneExport = {
            ...this.companyOneExport,
            loosingtalenttocompany: companyLosing
          }
        }
      });
    } else if (type == 'companytwo') {
      this.companiesLosingTwo = [];
      requestObject.companies = this.alternateCompanyNamesTwo;
      requestObject.companyids = [this.companyIdTwo];
      this.companyLosingLoaderTwo = true;
      this.companyInsightsService.getcompanylosingtalentto(requestObject).subscribe((response) => {
        if (response.status == "success") {
          this.companiesLosingTwo = response.aggregations.losingtalenttocompany;
          this.companytwoLoosingTalenCount = response.totalresultscount;

          this.showCountCompanyLosing = 5;

          this.companyLosingLoaderTwo = false;
          this.getCompaniesLosingLogo('companytwo');
          const companyLosing = this.companiesLosingTwo.map(loosing => {
            return { ...loosing, companylogo: loosing.companylogo, totalpercentage: this.getCompanyCompareTwoPercent(loosing.doc_count, 'loosing') }
              ;
          })
          this.companyTwoAISummary = {
            ...this.companyTwoAISummary,
            loosingtalenttocompany: companyLosing
          }

          this.companyTwoExport = {
            ...this.companyTwoExport,
            loosingtalenttocompany: companyLosing
          }
        }
      });
    }

  }

  getCompaniesLosingLogo(type) {
    if (type == 'companyone') {
      if (this.companiesLosingOne) {
        let companyLogoPayload = [];
        this.companiesLosingOne.map(item => {
          if (item?.id || item?.key) {
            companyLogoPayload.push({
              ...(item?.id && { id: item.id }),
              ...(item?.key && { name: item.key })
            });
          }
        });
        companyLogoPayload?.length &&
          this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
            if (res && res.status == "success") {
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = this.companiesLosingOne.find((item) => item.key === obj.key);
                if (matchingObj) {
                  let companyLogo = obj.companylogo
                  matchingObj.companylogo = companyLogo;
                  matchingObj.website = obj.website;
                }
                const companyLosing = this.companiesLosingOne.map(loosing => {
                  return { ...loosing, companylogo: loosing.companylogo, totalpercentage: this.getCompanyComparePercent(loosing.doc_count, 'loosing') }
                    ;
                })
                this.companyOneAISummary = {
                  ...this.companyOneAISummary,
                  loosingtalenttocompany: companyLosing
                }

                this.companyOneExport = {
                  ...this.companyOneExport,
                  loosingtalenttocompany: companyLosing
                }
              });
            }
          });
      }
    } else if (type == 'companytwo') {
      if (this.companiesLosingTwo) {
        let companyLogoPayload = [];
        this.companiesLosingTwo.map(item => {
          if (item?.id || item?.key) {
            companyLogoPayload.push({
              ...(item?.id && { id: item.id }),
              ...(item?.key && { name: item.key })
            });
          }
        });
        companyLogoPayload?.length &&
          this.personSearchService.getCompanyLogoV2(companyLogoPayload).subscribe((res: any) => {
            if (res && res.status == "success") {
              const resultName = res.data
              resultName.forEach(obj => {
                const matchingObj = this.companiesLosingTwo.find((item) => item.key === obj.key);
                if (matchingObj) {
                  let companyLogo = obj.companylogo
                  matchingObj.companylogo = companyLogo;
                  matchingObj.website = obj.website;
                }
                const companyLosing = this.companiesLosingTwo.map(loosing => {
                  return { ...loosing, companylogo: loosing.companylogo, totalpercentage: this.getCompanyCompareTwoPercent(loosing.doc_count, 'loosing') }
                    ;
                })

                this.companyTwoAISummary = {
                  ...this.companyTwoAISummary,
                  loosingtalenttocompany: companyLosing
                }
                this.companyTwoExport = {
                  ...this.companyTwoExport,
                  loosingtalenttocompany: companyLosing
                }
              });
            }
          });
      }
    }

  }

  getCompanyOneTitles(type) {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "current_jobtitle";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    if (type == 'companyone') {
      this.titlesCompanyOne = [];
      aggReq.companies = this.alternateCompanyNamesOne;
      aggReq.companyids = [this.companyIdOne];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.titleLoaderOne = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.titlesCompanyOne = response.data.aggregations.current_jobtitle;
        this.showCountJobtitle = 5;
        this.companyOneAISummary = {
          ...this.companyOneAISummary,
          titles: this.titlesCompanyOne
        }
        const titles = this.titlesCompanyOne.map(titles => {
          return { ...titles, totalpercentage: this.getCompanyComparePercent(titles.doc_count, 'company') }
            ;
        })

        this.companyOneExport = {
          ...this.companyOneExport,
          titles: titles
        }
        this.generateai();

        this.titleLoaderOne = false;
      });
    } else if (type == 'companytwo') {
      aggReq.companies = this.alternateCompanyNamesTwo;
      aggReq.companyids = [this.companyIdTwo];
      this.titlesCompanyTwo = [];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.titleLoaderTwo = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.titlesCompanyTwo = response.data.aggregations.current_jobtitle;
        this.showCountJobtitle = 5;
        this.titleLoaderTwo = false;
        this.companyTwoAISummary = {
          ...this.companyTwoAISummary,
          titles: this.titlesCompanyTwo
        }
        const titles = this.titlesCompanyTwo.map(titles => {
          return { ...titles, totalpercentage: this.getCompanyCompareTwoPercent(titles.doc_count, 'company') }
            ;
        })

        this.companyTwoExport = {
          ...this.companyTwoExport,
          titles: titles
        }
        this.generateai();

      });
    }

  }

  getCompanyOneEthnicity(type) {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "ethnicity";
    aggReq.startindex = 0;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    if (type == 'companyone') {
      this.ethnicityChartCompanyOne = [];
      aggReq.companies = this.alternateCompanyNamesOne;
      aggReq.companyids = [this.companyIdOne];
      this.ethnicityLoaderOne = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.ethnicityLoaderOne = false;
        const ethnicityData = response?.data?.aggregations?.ethnicity || [];
        this.ethnicityChartCompanyOne = this.fusionChartService.ethnicityChart(ethnicityData, response?.data?.totalResultCount);
        const ethnicityDataAi = this.ethnicityChartCompanyOne.data.map(x => ({
          key: x.label,
          doc_count: x.value + '%'
        }));
        this.companyOneAISummary = {
          ...this.companyOneAISummary,
          ethnicity: ethnicityDataAi
        }

        this.generateai();

      });
    } else if (type == 'companytwo') {
      this.ethnicityChartCompanyTwo = [];
      aggReq.companies = this.alternateCompanyNamesTwo;
      aggReq.companyids = [this.companyIdTwo];
      this.ethnicityLoaderTwo = true;
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        this.ethnicityLoaderTwo = false;
        const ethnicityData = response?.data?.aggregations?.ethnicity || [];
        this.ethnicityChartCompanyTwo = this.fusionChartService.ethnicityChart(ethnicityData, response?.data?.totalResultCount);
        const ethnicityDataAi = this.ethnicityChartCompanyTwo.data.map(x => ({
          key: x.label,
          doc_count: x.value + '%'
        }));
        this.companyTwoAISummary = {
          ...this.companyTwoAISummary,
          ethnicity: ethnicityDataAi
        }

        this.generateai();

      });
    }

  }

  getKeyPeopleCompaanyOneData(type) {
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    requestObject['calledvia'] = 'companypages';
    requestObject['sendkeypeople'] = true;
    requestObject['companytype'] = "Current";
    if (type == 'companyone') {

      this.keyPeopleLoaderCompanyOne = true;
      requestObject.companies = this.alternateCompanyNamesOne;
      requestObject.companyids = [this.companyIdOne];

      this.personSearchService.getPersonSearchRecommendCandidates(requestObject).subscribe((response) => {
        if (response && response?.data?.results) {
          const tempData = response.data.results;
          this.keyPeopleDataCompanyOne = tempData;
          this.showCountProfiles = 3;
          this.keyPeopleDataCompanyOne = this.keyPeopleDataCompanyOne.map(candidate => {
            candidate.currentLocation = candidate.location_name ? candidate.location_name : candidate.location_names && candidate.location_names.length ? candidate.location_names[0] :
              candidate.location_region && candidate.location_locality && candidate.location_country ?
                `${candidate.location_region}  ${candidate.location_locality}  ${candidate.location_country}` :
                candidate.location_region && candidate.location_country ? `${candidate.location_region}  ${candidate.location_country}` :
                  candidate.location_locality && candidate.location_country ? `${candidate.location_locality}  ${candidate.location_country}` :
                    candidate.location_region ? `${candidate.location_region}` :
                      candidate.location_locality ? `${candidate.location_locality}` : candidate.location_country ? `${candidate.location_country}` : '';
            return candidate;
          })
          this.keyPeopleLoaderCompanyOne = false;

          const keypeople = this.keyPeopleDataCompanyOne.map(people => ({
            id: people.id,
            full_name: people.full_name,
            job_title: people.job_title,
            currentLocation: people.currentLocation,
            linkedin_url: people.linkedin_url,
            twitter_url: people.twitter_url,
            facebook_url: people.facebook_url
          }));
          this.companyOneExport = {
            ...this.companyOneExport,
            keyPeople: keypeople
          }
        }
      });
    } else if (type == 'companytwo') {
      this.keyPeopleLoaderCompanyTwo = true;
      requestObject.companies = this.alternateCompanyNamesTwo;
      requestObject.companyids = [this.companyIdTwo];

      this.personSearchService.getPersonSearchRecommendCandidates(requestObject).subscribe((response) => {
        if (response && response?.data?.results) {
          const tempData = response.data.results;
          this.keyPeopleDataCompanyTwo = tempData;
          this.showCountProfiles = 3;

          this.keyPeopleDataCompanyTwo = this.keyPeopleDataCompanyTwo.map(candidate => {
            candidate.currentLocation = candidate.location_name ? candidate.location_name : candidate.location_names && candidate.location_names.length ? candidate.location_names[0] :
              candidate.location_region && candidate.location_locality && candidate.location_country ?
                `${candidate.location_region}  ${candidate.location_locality}  ${candidate.location_country}` :
                candidate.location_region && candidate.location_country ? `${candidate.location_region}  ${candidate.location_country}` :
                  candidate.location_locality && candidate.location_country ? `${candidate.location_locality}  ${candidate.location_country}` :
                    candidate.location_region ? `${candidate.location_region}` :
                      candidate.location_locality ? `${candidate.location_locality}` : candidate.location_country ? `${candidate.location_country}` : '';
            return candidate;
          })
          this.keyPeopleLoaderCompanyTwo = false;
          const keypeople = this.keyPeopleDataCompanyTwo.map(people => ({
            id: people.id,
            full_name: people.full_name,
            job_title: people.job_title,
            currentLocation: people.currentLocation,
            linkedin_url: people.linkedin_url,
            twitter_url: people.twitter_url,
            facebook_url: people.facebook_url
          }));
          this.companyTwoExport = {
            ...this.companyTwoExport,
            keyPeople: keypeople
          }
        }
      });
    }

  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

  getCompanySeniorityData(type) {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "seniority";
    aggReq.aggregatescount = 50;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    const customOrder = [
      'owner',
      'cxo',
      'partner',
      'vp',
      'director',
      'senior',
      'manager',
      'entry',
      'training',
      'unpaid'
    ];


    if (type == 'companyone') {
      aggReq.companies = this.alternateCompanyNamesOne;
      aggReq.companyids = [this.companyIdOne];
      this.seniorityLoaderCompanyOne = true;
      this.seniorityDataCompanyOne= {};
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        const seniorityDataCompanyOne = response.data.aggregations.seniority;
        const totalDocCount = seniorityDataCompanyOne.reduce((sum, item) => sum + item.doc_count, 0);

          const result = customOrder.map(orderKey => {
  const matched = seniorityDataCompanyOne.find(d => d.key === orderKey);
  return {
    key: orderKey,
    doc_count: matched ? matched.doc_count : 0
  };
});
        this.seniorityLoaderCompanyOne = false;
        console.log("sortedData", result);
        this.seniorityDataCompanyOne = this.fusionChartService.seniorityCompareChart(result, totalDocCount);
        this.companyOneAISummary = {
          ...this.companyOneAISummary,
          seniorities: this.seniorityDataCompanyOne
        }
        // const seniorityChart = { renderAt: `seniorityChart${this.companyNameTwo}`, type: 'bar2d', dataSource: { ...this.seniorityDataCompanyOne } };
        // delete seniorityChart['dataSource']['tooltext'];
        // this.companyOneExport = {
        //   ...this.companyOneExport,
        //   keyPeople: keypeople
        // }
        this.generateai();

      });
    } else if (type == 'companytwo') {
      aggReq.companies = this.alternateCompanyNamesTwo;
      aggReq.companyids = [this.companyIdTwo];
      this.seniorityLoaderCompanyTwo = true;
      this.seniorityDataCompanyTwo = {};
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((response) => {
        const seniorityDataCompanyTwo = response.data.aggregations.seniority;
        const totalDocCount = seniorityDataCompanyTwo.reduce((sum, item) => sum + item.doc_count, 0);

                const result = customOrder.map(orderKey => {
  const matched = seniorityDataCompanyTwo.find(d => d.key === orderKey);
  return {
    key: orderKey,
    doc_count: matched ? matched.doc_count : 0
  };
});
        this.seniorityLoaderCompanyTwo = false;

        this.seniorityDataCompanyTwo = this.fusionChartService.seniorityCompareChart(result, totalDocCount);
        this.companyTwoAISummary = {
          ...this.companyTwoAISummary,
          seniorities: this.seniorityDataCompanyTwo
        }
        this.generateai();

      });
    }

  }

  clearCompanyName(type, companyDetails) {
    if (type == 'companyone') {
      this.companyInsightsService.companycompareone = [];
      this.localStorageService.setItem('companyOneId', null);

      this.companyDetailsOne = null;
      this.genderChart.data = [];
      this.topLocationsCompanyOne = [];
      this.functionsCompanyOne = [];
      this.companiesGainingOne = [];
      this.companyIdOne = null;
      this.hiresAndAttritionObj = {};
      this.companiesLosingOne = [];
      this.seniorityDataCompanyOne.data = [];
      this.titlesCompanyOne = [];
      this.ethnicityChartCompanyOne.data = [];
      this.keyPeopleDataCompanyOne = [];
      this.hireDepartureTalentDataSource = {};
      this.companyOneAISummary = {};
      this.totalResultCountCompanyOne = 0;
      this.medianTanuresCompanyOneCount = 0;
      this.hireDepartureTalent = [];
      this.winningCompanyTrends = [];
      this.loosingCompanyTrends = [];
      this.talentmovementGraphData = [];
    } else if (type == 'companytwo') {
      this.companyInsightsService.companycomparetwo = [];
      this.companyDetailsTwo = null;
      this.genderChartCompanyTwo.data = [];
      this.topLocationsCompanyTwo = [];
      this.functionsCompanyTwo = [];
      this.companiesGainingTwo = [];
      this.companyIdTwo = null;
      this.localStorageService.setItem('companyTwoId', null);
      this.hiresAndAttritionObjCompanyTwo = {};
      this.companiesLosingTwo = [];
      this.seniorityDataCompanyTwo.data = [];
      this.titlesCompanyTwo = [];
      this.ethnicityChartCompanyTwo.data = [];
      this.keyPeopleDataCompanyTwo = [];
      this.hireDepartureTalentDataSourceTwo = {};
      this.companyTwoAISummary = {};
      this.totalResultCountCompanyTwo = 0;
      this.medianTenureCompanyTwoCount = 0;
      this.hireDepartureTalentTwo = [];
      this.winningTrendsCompanyTwo = [];
      this.loosingTrendsCompanyTwo = [];
      this.talentmovementGraphDataCompanyTwo = []
    }
    if (!this.companyIdOne && !this.companyIdTwo) {
      this.router.navigate(['/webbtree-company-list']);
    }
    this.generateai();


  }

  private getcompanywinninglosingtalent(type): Promise<any> {
    const hireDepartureTalentMovement: Record<string, IHireDepartureTalent> = {};
    this.aggReqObjectHandlerService.setShareRequestObject(new TIAggRequest());
    const requestObject = this.aggService.getRequestWithFilters();
    if (type == 'companyone') {
      this.hireDepartureTalent = [];

      requestObject.companies = this.alternateCompanyNamesOne;
      requestObject.resultsize = 250;
      requestObject.startindex = 0;
      requestObject.companyids = [this.companyIdOne];
      this.talentMovementCompanyOneLoaader = true;
      return new Promise((resolve) => {
        this.companyInsightsService.getcompanywinningTalentFrom(requestObject).subscribe((res: any) => {
          const winningtalents = res.aggregations.winningtalentfromcompany;
          this.winningCompanyTrends = res.aggregations.winningtrend
          this.companyInsightsService.getcompanylosingtalentto(requestObject).subscribe((response: any) => {
            const losingtalents = response.aggregations.losingtalenttocompany;
            this.loosingCompanyTrends = response.aggregations.losingtrend
            this.companyOneAISummary = {
              ...this.companyOneAISummary,
              winning: winningtalents,
              loosing: losingtalents
            }
            this.generateai();
            if (this.winningCompanyTrends.length || this.loosingCompanyTrends.length) {
              this.getTalentMovementGraph();
              this.talentMovementCompanyOneLoaader = false;
            } else {
              this.hireDepartureTalentDataSource = {};
              this.talentMovementCompanyOneLoaader = false;

            }


          })
          // set hires and departures graph data available here
        })
        return resolve(null);
      })
    } else if (type == 'companytwo') {
      this.hireDepartureTalentTwo = [];

      requestObject.companies = this.alternateCompanyNamesTwo;
      requestObject.resultsize = 250;
      requestObject.startindex = 0;
      requestObject.companyids = [this.companyIdTwo];
      this.talentMovementCompanyTwoLoaader = true;

      return new Promise((resolve) => {
        this.hireDepartureTalentDataSourceTwo = {};
        this.companyInsightsService.getcompanywinningTalentFrom(requestObject).subscribe((res: any) => {
          const winningtalents = res.aggregations.winningtalentfromcompany;
          this.winningTrendsCompanyTwo = res.aggregations.winningtrend
          this.companyInsightsService.getcompanylosingtalentto(requestObject).subscribe((response: any) => {
            const losingtalents = response.aggregations.losingtalenttocompany;

            this.loosingTrendsCompanyTwo = response.aggregations.losingtrend
            this.companyTwoAISummary = {
              ...this.companyTwoAISummary,
              winning: winningtalents,
              loosing: losingtalents
            }
            this.generateai();
            if (this.winningTrendsCompanyTwo.length || this.loosingTrendsCompanyTwo.length) {
              this.getTalentMovementGraphCompanyTwo();
              this.talentMovementCompanyTwoLoaader = false;

            } else {
              this.hireDepartureTalentDataSourceTwo = {};
              this.talentMovementCompanyTwoLoaader = false;
            }
          })
          // set hires and departures graph data available here
          this.dataAvailable.hiresAndDepartures = true;
          this.dataAvailable.winningLosingTalent = true;
        })
        return resolve(null);
      })
    }

  }

  getTalentMovementGraph() {
    const today = new Date();
    const months: string[] = [];
    const end = new Date(); // today
    end.setMonth(end.getMonth() - 1); // move to last month
    for (let i = 11; i >= 0; i--) {
      const d = new Date(end.getFullYear(), end.getMonth() - i, 1); // Day set to 1
      const date = moment(d).format('YYYY-MM-DD');
      months.push(date);
    }

    const winningMap = new Map(this.winningCompanyTrends.map(item => [item.key_as_string, item.doc_count]));
    const loosingMap = new Map(this.loosingCompanyTrends.map(item => [item.key_as_string, item.doc_count]));

    // Step 3: Combine into final array with all 12 months
    const mergedArray = months.map(month => ({
      key_as_string: moment(month).format('MMM yy'),
      winning: winningMap.get(month) ?? 0,
      loosing: loosingMap.get(month) ?? 0
    }));
    this.talentmovementGraphData = mergedArray;
    this.prepareHireDepartureTalentChartData();
  }

  private prepareHireDepartureTalentChartData(): void {
    this.hireDepartureTalentDataSource = {
      chart: {
        theme: 'fusion',
        drawcustomlegendicon: '1',
        showYAxisLine: 0,
        showYAxisValues: 1,
        plottooltext: '$label, $seriesname: $dataValue',
        palettecolors: '#FFA8A8,#95E1D3',
        labelFont: "Poppins",
        legendItemFont: "Poppins",
        showValues: '1',
        minPlotHeightForValue: "10",
        placeValuesInside: "0",
        plotHoverEffect: "1",
        legendItemFontSize: "12",
        baseFontSize: "12"
      },
      categories: [
        {
          category: this.talentmovementGraphData.map((item) => ({ label: item.key_as_string }))
        }
      ],
      dataset: [
        {

          seriesname: 'Losing',
          data: this.talentmovementGraphData.map((item) => ({ value: -item.loosing })),
        },
        {
          seriesname: 'Winning',
          data: this.talentmovementGraphData.map((item) => ({ value: item.winning }))
        },
        {
          seriesname: "Growth Ratio",
          renderas: "line",
          dashed: '1',
          showvalues: "0",
          // anchorbgcolor: "#FDCB50",
          color: "#827b7a",
          data: this.talentmovementGraphData.map((item) => ({ value: item.winning - item.loosing }))
        }
      ],
    };
  }

  getTalentMovementGraphCompanyTwo() {
    const today = new Date();
    const months: string[] = [];
    const end = new Date(); // today
    end.setMonth(end.getMonth() - 1); // move to last month
    for (let i = 11; i >= 0; i--) {
      const d = new Date(end.getFullYear(), end.getMonth() - i, 1); // Day set to 1
      const date = moment(d).format('YYYY-MM-DD');
      months.push(date);
    }

    const winningMap = new Map(this.winningTrendsCompanyTwo.map(item => [item.key_as_string, item.doc_count]));
    const loosingMap = new Map(this.loosingTrendsCompanyTwo.map(item => [item.key_as_string, item.doc_count]));

    // Step 3: Combine into final array with all 12 months
    const mergedArray = months.map(month => ({
      key_as_string: moment(month).format('MMM yy'),
      winning: winningMap.get(month) ?? 0,
      loosing: loosingMap.get(month) ?? 0
    }));
    this.talentmovementGraphDataCompanyTwo = mergedArray;
    this.prepareHireDepartureTalentChartDataTwo();

  }
  private cleanCompanyName(companyName: string): string {
    // replace - with space
    return companyName.replace(/-/g, ' ');
  }



  prepareHireDepartureTalentChartDataTwo() {
    this.hireDepartureTalentDataSourceTwo = {
      chart: {
        theme: 'fusion',
        drawcustomlegendicon: '1',
        showYAxisLine: 0,
        showYAxisValues: 1,
        plottooltext: '$label, $seriesname: $dataValue',
        palettecolors: '#FFA8A8,#95E1D3',
        labelFont: "Poppins",
        legendItemFont: "Poppins",
        showValues: '1',
        minPlotHeightForValue: "10",
        placeValuesInside: "0",
        plotHoverEffect: "1",
        legendItemFontSize: "12",
        baseFontSize: "12"
      },
      categories: [
        {
          category: this.talentmovementGraphDataCompanyTwo.map((item) => ({ label: item.key_as_string }))
        }
      ],
      dataset: [
        {

          seriesname: 'Losing',
          data: this.talentmovementGraphDataCompanyTwo.map((item) => ({ value: -item.loosing })),
        },
        {
          seriesname: 'Winning',
          data: this.talentmovementGraphDataCompanyTwo.map((item) => ({ value: item.winning }))
        },
        {
          seriesname: "Growth Ratio",
          renderas: "line",
          dashed: '1',
          showvalues: "0",
          // anchorbgcolor: "#FDCB50",
          color: "#827b7a",
          data: this.talentmovementGraphDataCompanyTwo.map((item) => ({ value: item.winning - item.loosing }))
        }
      ],
    };
  }

  openAddCompanyModal(type) {
    const modalRef = this.modalService.open(AddCompanyModalComponent, { windowClass: 'companyCompareModal', centered: true, backdrop: 'static', keyboard: false })
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (type == 'companyone') {
        this.companyIdOne = x?.data?.id;
        this.companyNameOne = x?.data?.name;
        this.companyInsightsService.companycompareone = [{ id: x?.data?.id, name: x?.data?.name }];
        this.localStorageService.setItem('companyOneId', this.companyIdOne);
        this.getDetailsOfCompanyOne();
        this.generateai();
      } else if (type == 'companytwo') {
        this.companyIdTwo = x?.data?.id;
        this.companyNameTwo = x?.data?.name;
        this.companyInsightsService.companycomparetwo = [{ id: x?.data?.id, name: x?.data?.name }];
        this.localStorageService.setItem('companyTwoId', this.companyIdTwo);
        this.getDetailsOfCompanyTwo();
        this.generateai();
      }
      this.modalService.dismissAll();
      if (this.companyIdOne && this.companyIdTwo) {
        const payload = {
          companies: [this.companyNameOne, this.companyNameTwo],
          id: [this.companyIdOne, this.companyIdTwo]
        }
        this.companyInsightsService.setCompanyInsightsHistory(payload, 'company comparison');
      }

    })


  }

  toggleShowMore(type) {
    if (type == 'jobtitle')
      this.showCountJobtitle = this.showCountJobtitle === 5 ? 10 : 5;
    if (type == 'companyLosing')
      this.showCountCompanyLosing = this.showCountCompanyLosing === 5 ? 10 : 5;
    if (type == 'companyWinning')
      this.showCountCompanyWinning = this.showCountCompanyWinning === 5 ? 10 : 5;
    if (type == 'functions')
      this.showCountFunctions = this.showCountFunctions === 5 ? 10 : 5;
    if (type == 'locations')
      this.showCountLocations = this.showCountLocations === 5 ? 10 : 5;
    if (type == 'profiles')
      this.showCountProfiles = this.showCountProfiles === 3 ? 10 : 3;
  }

  redirecttoCompanylist(company) {
    this.companyInsightsService.setCompanyListData(company);
    const companyinsightsFilter = this.filterDataHandlerService.fetchFilterData;
    this.localStorageService.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(companyinsightsFilter));
    const uniqueHash = this.hashService.generateUniqueHash();
    /**
     * Company Insights viewed
     */
    const companyInsightsParams = {
      "User ID": this.localStorageService.getItem('userdata').userid,
      "Company name": company.name,
      "Source": "compare",
      "Filters Applied": "none"

    }
    this.localStorageService.setItem('companyCurrency', 'USD')
    clevertap.event.push("Company Insights Viewed", companyInsightsParams);
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, companyinsightsFilter);
    const url = `/company-details/${company.id}?${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}`;
    window.open(url, "_blank");
  }


  getGrowthRateAttrtionRateData(type) {
    let request: AggregationRequest = new TIAggRequest();
    this.aggReqObjectHandlerService.setShareRequestObject(request);
    request = this.aggService.getRequestWithFilters();
    if (type == 'companyone') {
      request.companyids = [this.companyIdOne];
      request.companies = this.alternateCompanyNamesOne;
      this.aggReqObjectHandlerService.setShareRequestObject(request);
      const data = {
        ...request,
        companies: this.alternateCompanyNamesOne,
      };
      this.generateai();

      this.hiresAndAttritionObj = {};

      //Get company Attrition data
      this.personSearchService.getCompanyAttrition(data).subscribe((res: any) => {
        if (res && res.data) {
          const recentAttrtion = {
            "increaseRate": res.data?.increaseRate,
            "previousYearCount": res.data?.previousYearCount,
            "currentYearCount": res.data?.currentYearCount,
            "type": res.data?.type
          }
          this.hiresAndAttritionObj['recentAttrtion'] = recentAttrtion
        }
      })

      //Get company Growth Data
      this.personSearchService.getCompanyGrowth(data).subscribe((res: any) => {
        if (res && res.data) {
          const recentGrowth = {
            "increaseRate": res.data?.increaseRate,
            "previousYearCount": res.data?.previousYearCount,
            "currentYearCount": res.data?.currentYearCount,
            "type": res.data?.type
          }
          this.hiresAndAttritionObj['recentGrowth'] = recentGrowth;
        }
      })
    } else if (type == 'companytwo') {
      request.companyids = [this.companyIdTwo];
      request.companies = this.alternateCompanyNamesTwo;
      this.aggReqObjectHandlerService.setShareRequestObject(request);
      const data = {
        ...request,
        companies: this.alternateCompanyNamesTwo,
      };
      this.generateai();

      this.hiresAndAttritionObjCompanyTwo = {};

      //Get company Attrition data
      this.personSearchService.getCompanyAttrition(data).subscribe((res: any) => {
        if (res && res.data) {
          const recentAttrtion = {
            "increaseRate": res.data?.increaseRate,
            "previousYearCount": res.data?.previousYearCount,
            "currentYearCount": res.data?.currentYearCount,
            "type": res.data?.type
          }
          this.hiresAndAttritionObjCompanyTwo['recentAttrtion'] = recentAttrtion
        }
      })

      //Get company Growth Data
      this.personSearchService.getCompanyGrowth(data).subscribe((res: any) => {
        if (res && res.data) {
          const recentGrowth = {
            "increaseRate": res.data?.increaseRate,
            "previousYearCount": res.data?.previousYearCount,
            "currentYearCount": res.data?.currentYearCount,
            "type": res.data?.type
          }
          this.hiresAndAttritionObjCompanyTwo['recentGrowth'] = recentGrowth;
        }
      })
    }

  }

  handleRedirection(type: string, key: string, companytype: string) {
    const additionalFilters = {};
    switch (type) {
      case 'winningtalent': {
        additionalFilters['winningtalent'] = [key];
        additionalFilters['recentcompanyhires'] = true;
        break;
      }
      case 'losingtalent': {
        additionalFilters['losingtalent'] = [key];
        additionalFilters['recentcompanyattrition'] = true;
        break;
      }
      case 'recentGrowth': {
        additionalFilters['recentGrowth'] = [`Recent Hires - last 12 months`],
        additionalFilters['recentcompanyhires'] = true
        break;
      }
      case 'recentAttrtion': {
        additionalFilters['recentAttrtion'] = [`Recent Attrition - last 12 months`],
        additionalFilters['lastjobcompanyids'] = (companytype == 'companyone') ? [this.companyIdOne] : [this.companyIdTwo],
        additionalFilters['recentcompanyattrition'] = true;
        break;
      }
      case 'location': additionalFilters['mandatorylocations'] = [key]; break;
      case 'function': additionalFilters['mandatoryfunctions'] = [key]; break;
      case 'jobtitle': additionalFilters['mandatoryjobtitles'] = [key]; break;
    }
    if (companytype == 'companyone') {

      this.companyinsightsFilter['additionalFilters'] = additionalFilters;
      this.companyinsightsFilter['name'] = this?.companyDetailsOne?.name;
      this.companyinsightsFilter['alternative_names'] = this.alternateCompanyNamesOne;
      this.companyinsightsFilter['alternative_company_id'] = [this.companyIdOne];
    } else if (companytype == 'companytwo') {
      this.companyinsightsFilter['additionalFilters'] = additionalFilters;
      this.companyinsightsFilter['name'] = this?.companyDetailsTwo?.name;
      this.companyinsightsFilter['alternative_names'] = this.alternateCompanyNamesTwo;
      this.companyinsightsFilter['alternative_company_id'] = [this.companyIdTwo];
    }
    const uniqueHash = this.hashService.generateUniqueHash();
    this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, this.companyinsightsFilter);
    const url = `/person/search/listing?redirectSource=company-insights&${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}`;
    window.open(url, "_blank");
  }

  isBoolean(value: any) {
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
         else if (type == 'website'){
        link = "https://www." + link;
      }
    window.open(link, "_blank")
  }

  generateai() {
    // if(this.companyOneAISummary) {
    //   if(this.companyOneAISummary?.winningtalentfromcompany?.length) {
    //     this.companyOneAISummary.winningtalentfromcompany = _.map(this.companyOneAISummary.winningtalentfromcompany, obj => _.omit(obj, 'companylogo'));
    //   }
    // }
    // if(this.companyTwoAISummary) {
    //   if(this.companyTwoAISummary?.winningtalentfromcompany?.length) {
    //     this.companyTwoAISummary.winningtalentfromcompany = _.map(this.companyTwoAISummary.winningtalentfromcompany, obj => _.omit(obj, 'companylogo'));
    //   }
    // }
    const payload = {
      company_one: this.companyIdOne ? this.companyOneAISummary : {},
      company_two: this.companyIdTwo ? this.companyTwoAISummary : {},
      companyname: this.companyIdOne && !this.companyIdTwo ? [this.companyDetailsOne.name] : this.companyIdTwo && !this.companyIdOne ? [this.companyDetailsTwo.name] : [this.companyDetailsOne.name, this.companyDetailsTwo?.name],
      paramcompany_one: this.companyIdOne ? {
        "funding": this.companyDetailsOne.latest_funding_stage,
        "revenue": this.companyDetailsOne.total_funding_raised,
        professionalcount: this.totalResultCountCompanyOne,
        recenthires: this.hiresAndAttritionObj?.recentGrowth?.currentYearCount,
        recentattrition: this.hiresAndAttritionObj?.recentAttrtion?.currentYearCount,
        mediantenure: GlobalService.convertNumberToYearsAndMonths(this.medianTanuresCompanyOneCount),

      } : {},
      paramcompany_two: this.companyIdTwo ? {
        "funding": this.companyDetailsTwo?.latest_funding_stage,
        "revenue": this.companyDetailsTwo?.total_funding_raised,
        professionalcount: this.totalResultCountCompanyTwo,
        recenthires: this.hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount,
        recentattrition: this.hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount,
        mediantenure: GlobalService.convertNumberToYearsAndMonths(this.medianTenureCompanyTwoCount),


      } : {},
    }
    this.companyInsightsService.setCompanyComparisonforAI(payload);
  }

  getMedianTanureCount(type) {
    let aggReq: AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "total_tenure_median";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    if (type == 'companyone') {
      this.keyProfessionalOneLoader = true;
      aggReq.companies = this.alternateCompanyNamesOne;
      aggReq.companyids = [this.companyIdOne];
      this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

      this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((res: any) => {
        this.keyProfessionalOneLoader = false;
        if (res.data && res.data.aggregations && res.data.aggregations.total_tenure_median) {
          this.medianTanuresCompanyOneCount = res.data && res.data.aggregations && res.data.aggregations.total_tenure_median && res.data.aggregations.total_tenure_median.value;
        }
        this.generateai();
      });
    } else
      if (type == 'companytwo') {
        aggReq.companies = this.alternateCompanyNamesTwo;
        aggReq.companyids = [this.companyIdTwo];
        this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
        this.keyProfessionalTwoLoader = true;
        this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((res: any) => {
          this.keyProfessionalTwoLoader = false;
          if (res.data && res.data.aggregations && res.data.aggregations.total_tenure_median) {
            this.medianTenureCompanyTwoCount = res.data && res.data.aggregations && res.data.aggregations.total_tenure_median && res.data.aggregations.total_tenure_median.value;
          }
          this.generateai();
        });
      }

  }

  getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (tenure == null) {
      return 0;
    } else if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if (totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
        return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }


  returnSpanTag(text) {
    let spanTag = document.createElement("span");
    spanTag.className = 'median-tenure-text-size-detail';
    spanTag.innerHTML = text
    return spanTag;
  }

  fetchExportData(res) {
    if (res.status == 'export') {
      const ethnicityChartOne = { renderAt: `ethnicityChart-0`, type: 'doughnut2d', dataSource: __.cloneDeep({ ...this.ethnicityChartCompanyOne }) };
      ethnicityChartOne['width'] = '100%';
      delete ethnicityChartOne['dataSource']['tooltext'];
      if(ethnicityChartOne['dataSource'] && ethnicityChartOne['dataSource']['chart']) {
      ethnicityChartOne['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
      ethnicityChartOne['dataSource']['chart']['showLabels'] = "1";
      ethnicityChartOne['dataSource']['chart']['showValues'] = "1";
      }



      const ethnicityChartTwo = { renderAt: `ethnicityChart-1`, type: 'doughnut2d', dataSource: __.cloneDeep({ ...this.ethnicityChartCompanyTwo }) };
      ethnicityChartTwo['width'] = '100%';
      delete ethnicityChartTwo['dataSource']['tooltext'];
      if(ethnicityChartTwo['dataSource'] && ethnicityChartTwo['dataSource']['chart']) {
      ethnicityChartTwo['dataSource']['chart']['useEllipsesWhenOverflow'] = "0"
      ethnicityChartTwo['dataSource']['chart']['showLabels'] = "1";
      ethnicityChartTwo['dataSource']['chart']['showValues'] = "1";
      }
      const genderDiversityChart = { renderAt: `genderDiversityChart-0`, "width": "100%", "height": "300", dataSource: __.cloneDeep({ ...this.genderChart }) };
      genderDiversityChart['width'] = '100%';
      genderDiversityChart['type'] = genderDiversityChart['dataSource']['type'];
      if(genderDiversityChart['dataSource'] && genderDiversityChart['dataSource']['chart']) {
      genderDiversityChart['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
      genderDiversityChart['dataSource']['chart']['showLabels'] = "1";
      genderDiversityChart['dataSource']['chart']['showValues'] = "1";
      genderDiversityChart['dataSource']['chart']['chartLeftMargin'] = "10";
      genderDiversityChart['dataSource']['chart']['chartRightMargin'] = "10";
      genderDiversityChart['dataSource']['chart']['chartTopMargin'] = "10";
      genderDiversityChart['dataSource']['chart']['enableMultiSlicing'] = "0";
      genderDiversityChart['dataSource']['chart']['legendIconBorderPadding'] = "5";
      genderDiversityChart['dataSource']['chart']['showLegend'] = "1";
      genderDiversityChart['dataSource']['chart']['showPercentInTooltip'] = "1";
      }

      delete genderDiversityChart?.['dataSource']?.['type'];
      delete genderDiversityChart?.['dataSource']?.['width'];
      delete genderDiversityChart?.['dataSource']?.['chart']?.['width'];
      delete genderDiversityChart?.['dataSource']?.['height'];
      delete genderDiversityChart?.['dataSource']?.['chart']?.['height'];
      delete genderDiversityChart?.['dataSource']?.['chart']?.['renderAt'];
      delete genderDiversityChart?.['dataSource']?.['chart']?.['chartBottomMargin'];
      delete genderDiversityChart?.['dataSource']?.['chart']?.['legendNumColumns'];
      delete genderDiversityChart?.['dataSource']?.['chart']?.['pieRadius'];




      const genderDiversityChartTwo = { renderAt: `genderDiversityChart-1`, "width": "100%", "height": "300", dataSource: __.cloneDeep({ ...this.genderChartCompanyTwo }) };
      genderDiversityChartTwo['width'] = '100%';

      genderDiversityChartTwo['type'] = genderDiversityChartTwo['dataSource']['type'];
      if(genderDiversityChartTwo['dataSource'] && genderDiversityChartTwo['dataSource']['chart']) {
      genderDiversityChartTwo['dataSource']['chart']['useEllipsesWhenOverflow'] = "0";
      genderDiversityChartTwo['dataSource']['chart']['showLabels'] = "1";
      genderDiversityChartTwo['dataSource']['chart']['showValues'] = "1";
      genderDiversityChartTwo['dataSource']['chart']['chartLeftMargin'] = "10";
      genderDiversityChartTwo['dataSource']['chart']['chartRightMargin'] = "10";
      genderDiversityChartTwo['dataSource']['chart']['chartTopMargin'] = "10";
      genderDiversityChartTwo['dataSource']['chart']['enableMultiSlicing'] = "0";
      genderDiversityChartTwo['dataSource']['chart']['legendIconBorderPadding'] = "5";
      genderDiversityChartTwo['dataSource']['chart']['showLegend'] = "1";
      genderDiversityChartTwo['dataSource']['chart']['showPercentInTooltip'] = "1";
      }

      delete genderDiversityChartTwo?.['dataSource']?.['type'];
      delete genderDiversityChartTwo?.['dataSource']?.['width'];
      delete genderDiversityChartTwo?.['dataSource']?.['chart']?.['width'];
      delete genderDiversityChartTwo?.['dataSource']?.['height'];
      delete genderDiversityChartTwo?.['dataSource']?.['chart']?.['height'];
      delete genderDiversityChartTwo?.['dataSource']?.['chart']?.['renderAt'];
      delete genderDiversityChartTwo?.['dataSource']?.['chart']?.['chartBottomMargin'];
      delete genderDiversityChartTwo?.['dataSource']?.['chart']?.['legendNumColumns'];
      delete genderDiversityChartTwo?.['dataSource']?.['chart']?.['pieRadius'];
      const seniorityChart = { renderAt: `seniorityChart-0`, type: 'bar2d', dataSource: { ...this.seniorityDataCompanyOne } };
      seniorityChart['width'] = '100%';
      delete seniorityChart['dataSource']['tooltext'];

      const seniorityChartTwo = { renderAt: `seniorityChart-1`, type: 'bar2d', dataSource: { ...this.seniorityDataCompanyTwo } };
      seniorityChartTwo['width'] = '100%';
      delete seniorityChartTwo['dataSource']['tooltext'];

      const trendChart = { renderAt: `trendChart-0`, dataSource: { ...this.hireDepartureTalentDataSource } };
      trendChart['height'] = '450';
      trendChart['width'] = '100%';
      trendChart['type'] = 'stackedcolumn2dline';
      delete trendChart?.['dataSource']?.['width'];
      delete trendChart?.['dataSource']?.['chart']?.['width'];
      delete trendChart?.['dataSource']?.['height'];
      delete trendChart?.['dataSource']?.['chart']?.['height'];

      const trendChartTwo = { renderAt: `trendChart-1`, dataSource: { ...this.hireDepartureTalentDataSourceTwo } };
      trendChartTwo['height'] = '450';
      trendChartTwo['width'] = '100%';
      trendChartTwo['type'] = 'stackedcolumn2dline';
      delete trendChartTwo?.['dataSource']?.['width'];
      delete trendChartTwo?.['dataSource']?.['chart']?.['width'];
      delete trendChartTwo?.['dataSource']?.['height'];
      delete trendChartTwo?.['dataSource']?.['chart']?.['height'];

      const filtersData = this.filterDataHandlerService.fetchFilterData;
      const sharedReqData = this.aggReqObjectHandlerService.getSharedRequestObject();

      // remove "searchastext" from filter data, excluded filters & perform basic transformations/changes
      const excludedJobtitles = sharedReqData?.exclude_jobtitles.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
      const excludedLocations = sharedReqData?.exclude_locations.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
      const mandatorySkills = sharedReqData?.mandatoryskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
      const excludedPreferredSkills = sharedReqData?.exclude_preferredskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
      const excludedMandatorySkills = sharedReqData?.exclude_mandatoryskills.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
      const excludedFunctions = sharedReqData?.exclude_functions.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
  const excludedCompanies = sharedReqData?.exclude_companies.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedIndustries = sharedReqData?.exclude_industries.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedSchools = sharedReqData?.exclude_schoollocation.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
    const excludedPastJobTitles = sharedReqData?.exclude_pastjobtitles.map(item => item?.split('.searchastext')[0]?.split('.aisearch')[0]?.toLowerCase()).filter(Boolean);
      Object.entries(filtersData).forEach(([key, value]) => {
        if (value && Array.isArray(value)) {
          filtersData[key] = (Array.isArray(value) ? value : [value]).filter(Boolean).map((s) => {
            if (typeof s === 'string') {
              if (s.includes('.searchastext')) {
                return s.split('.searchastext')[0];
              } else {
                return s.split('.aisearch')[0];
              }
            } else {
              if (s.key.includes('.searchastext')) {
                return s.key.split('.searchastext')[0];
              } else {
                return s.key.split('.aisearch')[0];
              }
            }
          });

          if (key === 'seniority' || key === 'companysize') {
            filtersData[key] = filtersData[key].filter(item => (item.toLowerCase() != 'all'));
          } else if (key === 'jobTitleSelectedList') {
            filtersData[key] = filtersData[key].filter(item => !excludedJobtitles.includes(item.toLowerCase()));
          } else if (key === 'locationSelectedList') {
            filtersData[key] = filtersData[key].filter(item => !excludedLocations.includes(item.toLowerCase()));
          } else if (key === 'skillsSelectedList') {
  filtersData[key] = filtersData[key]
    .filter(item => {
      const skill = item?.toLowerCase();

      return !(
        excludedPreferredSkills.includes(skill) ||
        excludedMandatorySkills.includes(skill)
      );
    })
    .map(item => {
      const skill = item?.toLowerCase();

      return {
        key: item,
        isMandatory: mandatorySkills.includes(skill)
      };
    });
} else if (key === 'functionSelectedList') {
          filtersData[key] = filtersData[key].filter(item => !excludedFunctions.includes(item.toLowerCase()));
        }

        }
      });
          filtersData['excludedJobtitles'] = excludedJobtitles;
    filtersData['excludedLocations'] = excludedLocations;
    filtersData['excludedCompanies'] = excludedCompanies;
    filtersData['excludedIndustries'] = excludedIndustries;
    filtersData['excludedSchools'] = excludedSchools;
    filtersData['excludedPastJobTitles'] = excludedPastJobTitles;
    filtersData['excludedPreferredSkills'] = excludedPreferredSkills;
    filtersData['excludedMandatorySkills'] = excludedMandatorySkills;
    filtersData['excludedFunctions'] = excludedFunctions;
      // handle male/female change to men/women
      if (filtersData?.['gender']?.toLowerCase() == 'male') filtersData['gender'] = 'Men';
      else if (filtersData?.['gender']?.toLowerCase() == 'female') filtersData['gender'] = 'Women';

      const payload = {
        companyname: [this.companyNameOne, this.companyNameTwo],
        aiInsightsTabName: "overview",
        aiRequestPayload: {
          company_one: this.companyOneAISummary,
          company_two: this.companyTwoAISummary
        },
        aiInsightsParams: {
          company_one: this.companyIdOne ? {
            "funding": this.companyDetailsOne.latest_funding_stage,
            "revenue": this.companyDetailsOne.total_funding_raised,
            professionalcount: this.totalResultCountCompanyOne,
            recenthires: this.hiresAndAttritionObj?.recentGrowth?.currentYearCount,
            recentattrition: this.hiresAndAttritionObj?.recentAttrtion?.currentYearCount,
            mediantenure: GlobalService.convertNumberToYearsAndMonths(this.medianTanuresCompanyOneCount),

          } : {},
          company_two: this.companyIdTwo ? {
            "funding": this.companyDetailsTwo?.latest_funding_stage,
            "revenue": this.companyDetailsTwo?.total_funding_raised,
            professionalcount: this.totalResultCountCompanyTwo,
            recenthires: this.hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount,
            recentattrition: this.hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount,
            mediantenure: GlobalService.convertNumberToYearsAndMonths(this.medianTenureCompanyTwoCount),


          } : {}
        },
        companies: [
          {
            ...this.companyOneExport,
            chartdetails: [ethnicityChartOne, genderDiversityChart, seniorityChart, trendChart],
            companylogo: this.companyDetailsOne.companylogo,
            name: this.companyDetailsOne.name,
            industry: this.companyDetailsOne.industry,
            founded: this.companyDetailsOne.founded,
            location: this.companyDetailsOne.location,
            id: this.companyDetailsOne.id,
            size: this.companyDetailsOne.size,
            linkedin_url: this.companyDetailsOne.linkedin_url,
            facebook_url: this.companyDetailsOne.facebook_url,
            twitter_url: this.companyDetailsOne.twitter_url,
            headline: this.companyDetailsOne.headline,
            type: this.companyDetailsOne.type,
            total_funding_raised: this.companyDetailsOne.total_funding_raised,
            number_funding_rounds: this.companyDetailsOne.number_funding_rounds,
            latest_funding_stage: this.companyDetailsOne.latest_funding_stage,
            summary: this.companyDetailsOne.summary,
            tags: this.companyDetailsOne.tags,
            recentAttrition: this.hiresAndAttritionObj?.recentAttrtion?.currentYearCount,
            recentGrowth: this.hiresAndAttritionObj?.recentGrowth?.currentYearCount,
            totalresultcount: this.totalResultCountCompanyOne,
            mediantenure: GlobalService.convertNumberToYearsAndMonths(this.medianTanuresCompanyOneCount),

          },
          {
            ...this.companyTwoExport,
            chartdetails: [ethnicityChartTwo, genderDiversityChartTwo, seniorityChartTwo, trendChartTwo],
            companylogo: this.companyDetailsTwo.companylogo,
            name: this.companyDetailsTwo.name,
            industry: this.companyDetailsTwo.industry,
            founded: this.companyDetailsTwo.founded,
            location: this.companyDetailsTwo.location,
            id: this.companyDetailsTwo.id,
            size: this.companyDetailsTwo.size,
            linkedin_url: this.companyDetailsTwo.linkedin_url,
            facebook_url: this.companyDetailsTwo.facebook_url,
            twitter_url: this.companyDetailsTwo.twitter_url,
            headline: this.companyDetailsTwo.headline,
            type: this.companyDetailsTwo.type,
            total_funding_raised: this.companyDetailsTwo.total_funding_raised,
            number_funding_rounds: this.companyDetailsTwo.number_funding_rounds,
            latest_funding_stage: this.companyDetailsTwo.latest_funding_stage,
            summary: this.companyDetailsTwo.summary,
            tags: this.companyDetailsTwo.tags,
            recentAttrition: this.hiresAndAttritionObjCompanyTwo?.recentAttrtion?.currentYearCount,
            recentGrowth: this.hiresAndAttritionObjCompanyTwo?.recentGrowth?.currentYearCount,
            totalresultcount: this.totalResultCountCompanyTwo,
            mediantenure: GlobalService.convertNumberToYearsAndMonths(this.medianTenureCompanyTwoCount),


          }
        ],
        filters: filtersData
      }


      this.companyInsightsService.setCompanyCompareExportData(payload);


    }


  }

  exportInsights(payload) {
    const request = {
      data: payload
    }

    this.companyInsightsService.exportInsights(request).subscribe((res: any) => {
      if (res) {
        if (res.status === 'failure') {
          this.errorMessage = 'Error occured while generating the report';
        } else {
          this.successMessage = 'You will receive the company insights report on your email in a min.';
        }
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      } else {
        this.errorMessage = 'Error occured while generating the report';
      }
    }, () => {
      this.errorMessage = 'Error occured while generating the report';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    })
  }

  capitalizeFirstLetter(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).replace(/\s/g, "");
  }

  getAISummary(event) {
    this.aiSummary = event;
  }

  formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }
}
